import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "../api";

export default function Gallery({ lang }) {
  const [images, setImages] = useState([]);
  const [texts, setTexts] = useState(null);

  // null = brak lightboxa, liczba = index obrazka
  const [currentIndex, setCurrentIndex] = useState(null);

  // ----------------------- ŁADOWANIE -----------------------
  useEffect(() => {
    const load = async () => {
      try {
        const galleryRes = await axios.get(`${API_BASE}/api/gallery`);
        const textsRes = await axios.get(`${API_BASE}/api/texts`);

        setImages(galleryRes.data || []);
        setTexts(textsRes.data || {});
      } catch (err) {
        console.error("Gallery load error:", err);
      }
    };

    load();
  }, []);

  if (!texts) {
    return <section className="section">Loading…</section>;
  }

  const t = texts.gallery?.[lang] || {
    title: lang === "pl" ? "Galeria" : "Gallery",
    subtitle: "",
    empty: lang === "pl" ? "Brak zdjęć w galerii" : "No images yet",
  };

  const hasImages = images && images.length > 0;

  // ----------------------- LIGHTBOX -----------------------

  const closeLightbox = () => setCurrentIndex(null);

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i > 0 ? i - 1 : images.length > 0 ? images.length - 1 : null
    );
  };

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((i) =>
      i < images.length - 1 ? i + 1 : images.length > 0 ? 0 : null
    );
  };

  // ----------------------- RENDER -----------------------

  return (
    <section className="section">
      <h2 className="section-title">{t.title}</h2>
      <p className="section-subtitle">{t.subtitle}</p>

      {!hasImages ? (
        <p>{t.empty}</p>
      ) : (
        <div className="gallery-grid">
          {images.map((img, i) => (
            <div
              key={img}
              className="gallery-item"
              onClick={() => setCurrentIndex(i)}
            >
              <img src={`${API_BASE}/images/gallery/${img}`} alt="" />
            </div>
          ))}
        </div>
      )}

      {/* LIGHTBOX */}
      {currentIndex !== null && hasImages && (
        <div className="lightbox" onClick={closeLightbox}>
          {/* X (zamknij) */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              closeLightbox();
            }}
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              zIndex: 999999,
              fontSize: 32,
              color: "white",
              background: "rgba(0,0,0,0.45)",
              border: "none",
              borderRadius: "999px",
              width: 48,
              height: 48,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backdropFilter: "blur(4px)",
            }}
          >
            ✕
          </button>

          {/* STRZAŁKI */}
          {images.length > 1 && (
            <>
              <button
                className="lightbox-prev"
                onClick={showPrev}
                style={{ zIndex: 999998 }}
              >
                ‹
              </button>

              <button
                className="lightbox-next"
                onClick={showNext}
                style={{ zIndex: 999998 }}
              >
                ›
              </button>
            </>
          )}

          {/* OBRAZEK */}
          <img
            className="lightbox-img"
            src={`${API_BASE}/images/gallery/${images[currentIndex]}`}
            alt=""
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
